module.exports = __webpack_public_path__ + "static/media/10.36754da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/10.png
// module id = 927
// module chunks = 0